import serverApiV2Instance from "../../services/serverApiV2Instance";

export const getAssignedMemberUsers = (memberId:number) =>
  serverApiV2Instance.get(`/users/${memberId}/assigned-member-users`);